import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import * as calqSearchActions from '@redux/modules/calqSearch';
import {
  AreasOfLawFilter,
  DateRangeFilter,
  KeywordFilter,
  PublicationFilter,
  ResourceTypeFilter,
} from '@structures/SearchFilters';
import SearchFilterLeftRail from '@structures/SearchFilterLeftRail';

class SearchFilters extends React.Component {
  constructor(props) {
    super(props);

    const { dispatch } = this.props;

    this.calqSearchActions = bindActionCreators(calqSearchActions, dispatch);
  }
/* eslint-disable */
  render() {
    const {
      filtersOptions,
      filtersValues,
    } = this.props;
    const {
      filtersAppendOrRemove,
      filtersUpdate,
    } = this.calqSearchActions;

    return (
      <SearchFilterLeftRail>
        <KeywordFilter
          filterUpdate={filtersUpdate}
          filterValue={filtersValues.keyword}
          headerText="Refine results by"
          placeholder="Keywords"
        />
        <AreasOfLawFilter
          filterAppendOrRemove={filtersAppendOrRemove}
          filterOptions={filtersOptions.areaOfLawFilters}
          filterUpdate={filtersUpdate}
          filterValue={filtersValues.areasOfLaw}
        />
        <DateRangeFilter
          end={filtersValues.dateRange.end}
          filterUpdate={filtersUpdate}
          maxDate={moment()}
          start={filtersValues.dateRange.start}
          startDateProps={{
            scrollableYearDropdown: true,
            showYearDropdown: true,
            yearDropdownItemNumber: 10,
          }}
        />
        <PublicationFilter
          filterAppendOrRemove={filtersAppendOrRemove}
          filterOptions={filtersOptions.publicationFilters}
          filterUpdate={filtersUpdate}
          filterValue={filtersValues.publications}
        />
        <ResourceTypeFilter
          filterAppendOrRemove={filtersAppendOrRemove}
          filterOptions={filtersOptions.resourceTypeFilters}
          filterUpdate={filtersUpdate}
          filterValue={filtersValues.resourceTypes}
        />
      </SearchFilterLeftRail>
    );
  }
}
/* eslint-enable */

SearchFilters.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filtersOptions: PropTypes.shape({
    otherResourceCategoryFilters: PropTypes.arrayOf(PropTypes.object),
    practiceAreaFilters: PropTypes.arrayOf(PropTypes.object),
    publicationFilters: PropTypes.arrayOf(PropTypes.object),
    resourceTypeFilters: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  filtersValues: PropTypes.shape({
    dateRangeEnd: PropTypes.string,
    dateRangeStart: PropTypes.string,
    keyword: PropTypes.string,
    otherResources: PropTypes.arrayOf(PropTypes.object),
    practiceAreas: PropTypes.arrayOf(PropTypes.object),
    publications: PropTypes.arrayOf(PropTypes.object),
    resourceTypes: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

SearchFilters.displayName = 'SearchFilters';

export default connect()(SearchFilters);
